// extracted by mini-css-extract-plugin
module.exports = {"game":"GameBoard_game__TrMVA","startGameWrapper":"GameBoard_startGameWrapper__15KJH"};